import Icon from "../Icon";
import ProyectosPage from "../../pages/ProyectosPage";
import ProyectoPage from "../../pages/ProyectoPage";
import PlantillasPage from "../../pages/PlantillasPage";
import NotionProjectsPage from "../../pages/NotionProjectsPage";

// Seccion Proyectos: pestanas (gestor, protocolos, Notion) y la pagina de cada una.
// El estado vive en App porque lo comparten el buscador global y los modales.

export default function SeccionProyectos({ projTab, setProjTab, projAbierto, setProjAbierto, setProjFiltros, proyectos, users, teams, currentUser, festivos, setModal, crono, agendaTiposData, misPasos, showToast, notionItems, integrations, token, syncNotion, upsertNotionItem, removeNotionItem, reloadIntegrations, seleccionNotionInicial, onSeleccionNotionVista }) {
  return (
    <>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",padding:16,gap:12}}>
        <div className="filters-bar" style={{display:"flex",gap:6,flexShrink:0}}>
          {[["general","kanban-fill","Mis proyectos"],["plantillas","clipboard","Plantillas"],["notion","file-earmark-text","Notion"]].map(([k,ic,label])=>(
            <button key={k} onClick={()=>{setProjTab(k);setProjAbierto(null);proyectos.setDetalle(null);}} className="btn"
              style={{padding:"6px 14px",borderRadius:9,cursor:"pointer",fontSize:12,fontFamily:"var(--font)",
                border:`1px solid ${projTab===k?"var(--accent)":"var(--border)"}`,
                background:projTab===k?"var(--accent-bg)":"var(--surface)",
                color:projTab===k?"var(--accent)":"var(--text2)",
                fontWeight:projTab===k?700:500,display:"flex",alignItems:"center",gap:6}}>
              <Icon name={ic} size={12} color={projTab===k?"var(--accent)":"var(--text2)"}/>{label}
            </button>
          ))}
        </div>

        <div style={{flex:1,overflowY:"auto",minHeight:0}}>
          {projTab==="general"&&!projAbierto&&(
            <ProyectosPage
              proyectos={proyectos.proyectos} cargando={proyectos.cargando}
              users={users} teams={teams} currentUser={currentUser}
              festivos={festivos}
              historial={proyectos.historial}
              onCargarHistorial={proyectos.loadHistorialReciente}
              onFiltros={setProjFiltros}
              onAbrir={p=>{setProjAbierto(p.id);proyectos.loadProyecto(p.id);}}
              onNuevo={()=>setModal("nuevoProyecto")}/>
          )}

          {projTab==="general"&&projAbierto&&(
            <ProyectoPage
              detalle={proyectos.detalle} cargando={proyectos.cargando}
              currentUser={currentUser} teams={teams} users={users} festivos={festivos}
              onVolver={()=>{setProjAbierto(null);proyectos.setDetalle(null);}}
              onCambiarTarea={(tid,patch)=>proyectos.updateTarea(projAbierto,tid,patch)}
              onBorrarTarea={t=>setModal({type:"borrarPaso", tarea:t, projectId:projAbierto})}
              onNuevoPaso={()=>setModal({type:"nuevoPaso", projectId:projAbierto})}
              onCargarTiempo={proyectos.loadTiempo}
              onEditarProyecto={p=>setModal({type:"editarProyecto", proyecto:p})}
              onEditarPaso={t=>setModal({type:"editarPaso", paso:t, projectId:projAbierto})}
              onGuardarProtocolo={(p,pasos)=>setModal({type:"guardarProtocolo", proyecto:p, pasos})}
              onArchivar={p=>setModal({type:"archivarProyecto", proyecto:p})}
              onDesarchivar={async p=>{ await proyectos.desarchivarProyecto(p.id); }}
              onBorrar={p=>setModal({type:"borrarProyecto", proyecto:p})}
              /* El lienzo del flujo crea, borra y conecta pasos sin pasar
                 por los modales: alli la confirmacion la da el propio
                 panel, que avisa de cuantas conexiones se lleva. */
              onCrearPaso={d=>proyectos.createTarea(projAbierto,d)}
              onBorrarPasoDirecto={id=>proyectos.deleteTarea(projAbierto,id)}
              onCrearDependencia={d=>proyectos.crearDependencia(projAbierto,d)}
              onEditarDependencia={(did,d)=>proyectos.editarDependencia(projAbierto,did,d)}
              onBorrarDependencia={did=>proyectos.borrarDependencia(projAbierto,did)}
              onGuardarPosiciones={nodos=>proyectos.guardarPosiciones(projAbierto,nodos)}
              crono={crono} agendaTiposData={agendaTiposData} misPasos={misPasos}
              showToast={showToast}/>
          )}

          {projTab==="plantillas"&&!projAbierto&&(
            <PlantillasPage
              plantillas={proyectos.plantillas} currentUser={currentUser}
              onCargar={proyectos.loadPlantillas}
              /* Un protocolo se abre con el MISMO editor que un
                 proyecto: es lo que hace que no haya una segunda
                 pantalla que mantener. */
              onAbrir={p=>{setProjAbierto(p.id);proyectos.loadProyecto(p.id);}}
              onUsar={p=>setModal({type:"usarProtocolo", plantilla:p})}/>
          )}

          {projTab==="plantillas"&&projAbierto&&(
            <ProyectoPage
              detalle={proyectos.detalle} cargando={proyectos.cargando}
              currentUser={currentUser} teams={teams} users={users} festivos={festivos}
              onVolver={()=>{setProjAbierto(null);proyectos.setDetalle(null);}}
              onCambiarTarea={(tid,patch)=>proyectos.updateTarea(projAbierto,tid,patch)}
              onBorrarTarea={t=>setModal({type:"borrarPaso", tarea:t, projectId:projAbierto})}
              onNuevoPaso={()=>setModal({type:"nuevoPaso", projectId:projAbierto})}
              onCargarTiempo={proyectos.loadTiempo}
              onEditarProyecto={p=>setModal({type:"editarProyecto", proyecto:p})}
              onEditarPaso={t=>setModal({type:"editarPaso", paso:t, projectId:projAbierto})}
              onCrearPaso={d=>proyectos.createTarea(projAbierto,d)}
              onBorrarPasoDirecto={id=>proyectos.deleteTarea(projAbierto,id)}
              onCrearDependencia={d=>proyectos.crearDependencia(projAbierto,d)}
              onEditarDependencia={(did,d)=>proyectos.editarDependencia(projAbierto,did,d)}
              onBorrarDependencia={did=>proyectos.borrarDependencia(projAbierto,did)}
              onGuardarPosiciones={nodos=>proyectos.guardarPosiciones(projAbierto,nodos)}
              crono={crono} agendaTiposData={agendaTiposData} misPasos={misPasos}
              showToast={showToast}/>
          )}

          {projTab==="notion"&&(
            <NotionProjectsPage
              notionItems={notionItems}
              integration={integrations.find(i=>i.provider==="notion")}
              token={token}
              onSync={syncNotion}
              onConnect={()=>setModal("integrations")}
              onItemUpdated={upsertNotionItem}
              onItemRemoved={removeNotionItem}
              onItemsChanged={reloadIntegrations}
              seleccionInicial={seleccionNotionInicial} onSeleccionVista={onSeleccionNotionVista}
              showToast={showToast}/>
          )}
        </div>
      </div>
    </>
  );
}
